import HttpService from '../HttpService'

export async function getTimeData (id, store, locale) {
  try {
    const { data } = await HttpService.query()
      .setPath('/view/time/' + id)
      .setParams({ lang: locale })
      .get()
    store.commit('setInfo', data)
    return data
  } catch (e) {
    return null
  }
}
